import { render, staticRenderFns } from "./75000001.vue?vue&type=template&id=20f987c6&scoped=true&"
import script from "./75000001.vue?vue&type=script&lang=js&"
export * from "./75000001.vue?vue&type=script&lang=js&"
import style0 from "./75000001.vue?vue&type=style&index=0&id=20f987c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f987c6",
  null
  
)

export default component.exports